import {
  AcceptChallengeRequestInput,
  AcceptChallengeResult,
  AcceptChallengeResultTypenames,
} from '@varo/graphql-schema-types';
import AcceptChallenge from 'services/graphql/mutations/AcceptChallenge';
import useCancellableMutation from 'shared/hooks/useCancellableMutation';

type AcceptChallengeArgs = {
  challengeId?: string;
  otpCode?: string;
  input?: AcceptChallengeRequestInput;
};

const useAcceptChallengeGql = () => {
  const [{ fetching, error, data }, executeMutation] = useCancellableMutation<{
    acceptChallenge: AcceptChallengeResult;
  }>(AcceptChallenge);

  const acceptChallenge = (args: AcceptChallengeArgs) => executeMutation(args);

  const isVerified =
    data?.acceptChallenge?.__typename ===
      AcceptChallengeResultTypenames.AcceptChallengeSuccess &&
    data.acceptChallenge.challengeVerified;

  const challengeId =
    data?.acceptChallenge?.__typename ===
      AcceptChallengeResultTypenames.AcceptChallengeSuccess &&
    data.acceptChallenge.challengeId;

  const responseError =
    data?.acceptChallenge?.__typename ===
      AcceptChallengeResultTypenames.AcceptChallengeError &&
    data.acceptChallenge;

  return {
    fetching,
    responseError,
    apiError: error,
    data,
    isVerified,
    challengeId,
    acceptChallenge,
  };
};

export default useAcceptChallengeGql;
